// Enable click with enter key on labels.
function triggerLabel () {
	"use strict";
	document.querySelectorAll('.tab-box .radio-trigger').forEach(function (trigger) {
		trigger.setAttribute('tabindex', 0);
		trigger.onfocus = function (focusEvent) {
			focusEvent.target.onkeydown = function (keyEvent) {
				keyEvent.stopImmediatePropagation();
				if (keyEvent.key === 'Enter') {
					focusEvent.target.click();
				}
			};
		};
	});
}

// Listen for tab key, add body class.
function handleTab (e) {
	"use strict";
	if (e.keyCode === 9) {
		triggerLabel();
		document.body.classList.add('user-tabbing');
		window.removeEventListener('keydown', handleTab);
	}
}

window.onload = function () {
  "use strict";
  window.addEventListener('keydown', handleTab);
};